/**
 * Bitacora de eventos del sistema (sincronizaciones con Random).
 *
 * Cada corrida dice si resulto y que hizo con el catalogo: cuantos productos
 * actualizo, cuantos entraron nuevos y cuantos dejo de informar Random — y de
 * esos, si se borraron o quedaron esperando al administrador (RND-01). Si
 * fallo, el mensaje de error se muestra tal cual: el administrador tiene que
 * poder decirle al soporte de Random que paso exactamente.
 */
import type { SincronizacionRandom } from '@elcarpintero/compartido';

import { fechaHora, numero } from '../../utilidades/formato';
import { Icono } from '../comunes/Icono';

export interface LineaTiempoProps {
  sincronizaciones: SincronizacionRandom[];
}

/** Una frase por cosa que paso; lo que no paso no se nombra. */
function resumenDe(corrida: SincronizacionRandom): string {
  const partes = [`${numero(corrida.productosActualizados)} productos actualizados`];

  if (corrida.productosNuevos > 0) partes.push(`${numero(corrida.productosNuevos)} nuevos`);

  if (corrida.productosEliminados > 0) {
    partes.push(`${numero(corrida.productosEliminados)} borrados porque Random ya no los informa`);
  }

  const esperando = corrida.productosNoInformados - corrida.productosEliminados;
  if (esperando > 0) {
    partes.push(`${numero(esperando)} que Random dejó de informar, sin borrar`);
  }

  return partes.join(' · ');
}

export function LineaTiempo({ sincronizaciones }: LineaTiempoProps) {
  return (
    <ol className="timeline">
      {sincronizaciones.map((corrida) => (
        <li className="tl-item" key={corrida.id}>
          <span className={corrida.exitosa ? 'tl-punto ok' : 'tl-punto critico'}>
            <Icono nombre={corrida.exitosa ? 'sincro' : 'alerta'} />
          </span>
          <div className="tl-cuerpo">
            <p className="t">
              {corrida.exitosa ? 'Catálogo sincronizado' : 'La sincronización falló'}
            </p>
            <p className="d">
              {corrida.exitosa ? resumenDe(corrida) : (corrida.mensajeError ?? 'Random no respondió')}
            </p>
            <p className="h">
              <time dateTime={corrida.iniciadaEn}>{fechaHora(corrida.iniciadaEn)}</time>
            </p>
          </div>
        </li>
      ))}
    </ol>
  );
}
